<template>
  <div class="modal-card">
    <div class="modal-card-head">
      <p class="modal-card-title">Create new period</p>
    </div>
    <div class="modal-card-body">
      <div class="columns">
        <div class="column">
          <p>When a new period is created all open questionnaires are closed and new questionnaires are opened for all current countries.</p>
          <b-field label="New period name">
            <b-input type="text" v-model="name" placeholder="2020 1st Q"></b-input>
          </b-field>
        </div>
      </div>
    </div>
    <div class="modal-card-foot">
      <b-button @click="$parent.close()">Cancel</b-button>
      <b-button class="is-primary" :disabled="saving" :loading="saving" @click="addPeriod">Add period</b-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        saving: false,
        name: ''
      }
    },
    methods: {
      addPeriod() {
        if (this.name) {
          this.saving = true;
          this.$http.post("api/period/" + this.name)
            .then(resp => {
              if (resp.data) {
                this.$buefy.notification.open({
                  duration: 8000,
                  message: "Period added and new questionnaires made",
                  type: 'is-success',
                })
              } else {
                this.$buefy.notification.open({
                  duration: 8000,
                  message: "Something went wrong. Please try again later.",
                  type: 'is-danger',
                })
              }
              this.$emit('refresh');
              this.$parent.close();
            }).catch(err => {
              this.saving = false;
              console.error(err);
            });
        } else {
          this.$buefy.notification.open({
            duration: 4000,
            message: "Please fill out the field",
            type: 'is-danger',
          })
        }
      },
    }
  }
</script>
